export const buildPromptPopupStylesheet = (builder, device, cta, variant) => {
  const options = { ...variant.options };
  const buttonColor = options["prompt-button-color"] || "#0D42E4";
  const position = options["prompt-position"] || "center";

  let horizontal;
  if (builder == true) {
    horizontal =
      position === "left"
        ? "margin-left: 0 !important; margin-right: auto !important;"
        : position === "right"
        ? "margin-left: auto !important; margin-right: 0 !important;"
        : "margin-inline: auto !important;";
  } else {
    horizontal =
      position === "left"
        ? "left: 20px; right: auto; margin-inline: 0;"
        : position === "right"
        ? "right: 20px; left: auto; margin-inline: 0;"
        : "left: 0; right: 0; margin-inline: auto;";
  }

  // prettier-ignore
  const styles =
`@keyframes cf-prompt-slide-up {
  from { transform: translateY(60px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}
@keyframes cf-prompt-slide-down {
  from { transform: translateY(0);    opacity: 1; }
  to   { transform: translateY(60px); opacity: 0; }
}
@keyframes cf-prompt-collapse-in {
  from { transform: scale(0.3); opacity: 0; }
  to   { transform: scale(1);   opacity: 1; }
}

.cf-prompt-popup[data-cta-id="${cta.id}"] .cf-prompt-btn-standalone {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  cursor: pointer;
}

.cf-prompt-popup[data-cta-id="${cta.id}"] {
  cursor: pointer;
  position: ${builder == true ? "relative !important" : "fixed"};
  display: ${builder == true ? "block !important" : "none"};
  bottom: ${builder == true ? "initial !important" : "20px"};
  z-index: 100002;
  user-select: none;
  width: fit-content;
  max-width: ${builder == true ? "100%" : "calc(100vw - 40px)"};
  ${horizontal}
}

.cf-prompt-popup[data-cta-id="${cta.id}"] .cf-prompt-pill {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 50px;
  padding: 10px 10px 10px 20px;
  gap: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  overflow: hidden;
}

.cf-prompt-popup[data-cta-id="${cta.id}"] .cf-prompt-typewriter {
  all: initial !important;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  color: #1a1a1a !important;
  line-height: 1.4 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  min-width: 0 !important;
  cursor: pointer !important;
}

.cf-prompt-popup[data-cta-id="${cta.id}"] .cf-prompt-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cf-prompt-popup[data-cta-id="${cta.id}"] .cf-prompt-btn .svg-inline--fa {
  display: var(--fa-display, inline-block);
  color: ${options["prompt-icon-color"] || "#fff"};
  font-size: 18px;
  height: 1em;
  overflow: visible;
}

.cf-prompt-popup[data-cta-id="${cta.id}"] .cf-prompt-branding {
  text-align: center;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-size: 11px !important;
  color: rgba(0,0,0,0.4) !important;
  margin-top: 5px;
  padding: 0 4px;
  user-select: none;
}

body.modal-open .variant-edit-canvas .cf-prompt-popup[data-cta-id="${cta.id}"] {
  display: none !important;
}
`;

  if (builder == true) {
    return (
      styles +
      `
.cta${cta.id}.cf-prompt-popup {
  position: relative !important;
  bottom: initial !important;
  right: initial !important;
  left: initial !important;
}
`
    );
  }

  return styles;
};
